import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';

export function enrollPush(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('enrollPush')) {
        return;
    }

    return function(nickname: string): Promise<{ token: string; nickname: string }> {
        return messageBus
            .sendRequest<{ status: number; message?: string; fcmToken: string; nickname: string }>(
                `executeDynamicPlatformAPI`,
                Maybe.just({ functionName: 'enrollPush', args: [nickname] }).map(JSON.stringify)
            )
            .then(response => {
                if (response.value.status !== 0) {
                    throw new Error(response.value.message);
                }

                return { token: response.value.fcmToken, nickname: response.value.nickname };
            });
    };
}

export function unenrollPush(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('unenrollPush')) {
        return;
    }

    return function(): Promise<void> {
        return messageBus
            .sendRequest<{ status: number; message?: string; fcmToken: string; nickname: string }>(
                `executeDynamicPlatformAPI`,
                Maybe.just({ functionName: 'unenrollPush', args: [] }).map(JSON.stringify)
            )
            .then(response => {
                if (response.value.status !== 0) {
                    throw new Error(response.value.message);
                }
                return;
            });
    };
}
